import * as SERVICE_LOG from '@/constants/service-log';

export { SERVICE_LOG };

// AUTHENTICATION ROUTES
// 1) Authenticate with LDAP (Does Not Require Auth):
/** @return {string} */
export function AUTHENTICATION_URL() {
  return '/api/auth/login?app=pt';
}
// 2) Renew Auth Token:
/** @return {string} */
export function AUTHENTICATION_RENEW_URL() {
  return '/api/auth/renew';
}
// 3) Get Logged In User:
/** @return {string} */
export function GET_LOGGED_IN_USER_URL() {
  return '/api/auth/logged_in_user';
}

// HEALTH CHECK ROUTES
// 1) Authenticate with LDAP (Does Not Require Auth):
/** @return {string} */
export function HEALTH_CHECK_URL() {
  return '/api/health';
}

// MEDICAID PROCEDURE ROUTES
// 1) Get medicaid procedure list:
/** @return {string} */
export function GET_MEDICAID_PROCEDURES_LIST_URL() {
  return '/api/medicaid_procedures';
}

// PT SCHEDULER ROUTES
// 1) Get scheduler provider list:
/** @return {string} */
export function GET_SCHEDULER_PROVIDER_LIST_URL(searchString) {
  return `/api/pt_scheduler/providers?search=${searchString}`;
}
// 2) Get Student Service List (PT Service By Provider):
/** @return {string} */
export function GET_STUDENT_SERVICE_LIST_BY_PROVIDER_URL(providerUserId, schoolId, unassignedBool) {
  return `/api/pt_scheduler/students_services_by_provider?provideruserid=${providerUserId}&schoolid=${schoolId}&unassignedonly=${unassignedBool}`;
}
// 3) Get Scheduler Student List:
/** @return {string} */
export function GET_SCHEDULER_STUDENT_LIST_URL(searchString) {
  return `/api/pt_scheduler/students?search=${searchString}`;
}
// 4) Get School List:
/** @return {string} */
export function GET_SCHEDULER_SCHOOL_LIST_URL(searchString) {
  return `/api/pt_scheduler/schools?search=${searchString}`;
}
// 5) Get Student Services List (PT Service By Student):
/** @return {string} */
export function GET_STUDENT_SERVICE_LIST_BY_STUDENT_URL(studentId) {
  return `/api/pt_scheduler/students_services_by_student?studentid=${studentId}`;
}
// 6) Provider List Search for Add New Provider to Service (PT Service By Student):
/** @return {string} */
export function ADD_NEW_PROVIDER_TO_SERVICE_URL(serviceId, searchString) {
  return `/api/pt_scheduler/students_services_by_student/${serviceId}/providers?search=${searchString}`;
}
// 7) Add a Provider to a Students Service and Team:
/** @return {string} */
export function ADD_PROVIDER_TO_STUDENT_SERVICE_AND_TEAM_URL() {
  return '/api/pt_scheduler/student_services/providers';
}
// 8) Remove a Provider from a Students Service and Team:
/** @return {string} */
export function REMOVE_PROVIDER_FROM_STUDENT_SERVICE_AND_TEAM_URL(providerId) {
  return `/api/pt_scheduler/student_services/providers/${providerId}`;
}

// PT SERVICE LOG ROUTES
// 1) Get active provider list
/** @return {string} */
export function PTSL_GET_ACTIVE_PROVIDER_LIST_URL(search) {
  return `/api/pt_service_logs/providers/active?search=${search}`;
}
// 1) Get provider list:
/** @return {string} */
export function PTSL_PROVIDER_LIST_URL(search = null, provideruserid = null) {
  const baseUrl = '/api/pt_service_logs/providers';
  return search || provideruserid ? `${baseUrl}?search=${search}&provideruserid=${provideruserid}` : baseUrl;
}
// 2) Get providers school list:
/** @return {string} */
export function PTSL_PROVIDERS_SCHOOL_LIST_URL(providerUserId, search) {
  return `/api/pt_service_logs/providers/${providerUserId}/schools?search=${search}`;
}
// 3) Get providers student services list:
/** @return {string} */
export function PTSL_PROVIDERS_STUDENT_SERVICES_LIST_URL(providerUserId, sort) {
  return `/api/pt_service_logs/providers/${providerUserId}/student_services?sort=${sort}`;
}
// 4) Create a new PT Session:
/** @return {string} */
export function PTSL_URL() {
  return '/api/pt_service_logs';
}
// 5) Update a PT Session:
/** @return {string} */
export function PTSL_UPDATE_URL(sessionId) {
  return `/api/pt_service_logs/${sessionId}`;
}
// 6) Get PT Session By ID:
/** @return {string} */
export function PTSL_GET_PT_SESSION_URL(sessionId) {
  return `/api/pt_service_logs/${sessionId}`;
}
// 7) Delete PT Session:
/** @return {string} */
export function DELETE_PT_SESSION_URL(sessionId) {
  return `/api/pt_service_logs/${sessionId}`;
}
// 8) Get Student List For PT Session Listing DDL:
/** @return {string} */
export function PTSL_GET_STUDENT_LIST_FOR_DDL_URL(search) {
  return `/api/pt_service_logs/students?search=${search}`;
}
// 9) PT Session Listing:
/** @return {string} */
export function PTSL_PT_SESSION_LISTING_URL(fromString, toString, providerUserId, studentId, locationId) {
  return `/api/pt_service_logs/from=${fromString}&to=${toString}&provideruserid=${providerUserId}&studentid=${studentId}&locationid=${locationId}`;
}
// 10) Dashboard Listing:
/** @return {string} */
export function PTSL_DASHBOARD_LISTING_URL(numberOfDays) {
  return `/api/pt_service_logs/dashboard?days=${numberOfDays}`;
}
// 11) Get Absent Type Values:
/** @return {string} */
export function ABSENT_TYPES_URL() {
  return '/api/pt_service_logs/absent_types';
}
// 12) Get Student Absent Reason Values:
/** @return {string} */
export function ABSENT_REASONS_URL() {
  return '/api/pt_service_logs/absent_reason';
}
// 13) Get Provider Absent Alternative Values:
/** @return {string} */
export function ABSENT_ALTERNATIVES_URL() {
  return '/api/pt_service_logs/absent_alternative';
}
// 14) Get Group Types:
/** @return {string} */
export function GROUP_TYPES_URL() {
  return '/api/pt_service_logs/group_types';
}
// 15) Get Delivery Modes:
/** @return {string} */
export function DELIVERY_MODES_URL() {
  return '/api/pt_service_logs/delivery_modes';
}
// 16) Get Service Delivered Values:
/** @return {string} */
export function SERVICE_DELIVERED_URL() {
  return '/api/pt_service_logs/service_delivered';
}
// 17) Get Supervisor Check Flags:
/** @return {string} */
export function GET_SUPERVISOR_FLAGS_URL(sessionId) {
  return `/api/pt_service_logs/supervise_check?sessionId=${sessionId}`;
}

// SCHOOL ROUTES
// 1) Get school list:
/** @return {string} */
export function GET_SCHOOL_LIST_URL(searchString = null) {
  const baseUrl = '/api/schools';
  return searchString ? `${baseUrl}?search=${searchString}` : baseUrl;
}

// SERVICE LOCATION ROUTES
// 1) Get service location list:
/** @return {string} */
export function GET_SERVICE_LOCATIONS_URL(searchString) {
  return `/api/service_locations?search=${searchString}`;
}

// STUDENT ROUTES
// 1) Get Student By ID:
/** @return {string} */
export function GET_STUDENTS_BY_ID_URL(studentId) {
  return `/api/students/${studentId}`;
}

// USER ROUTES
// 1) Get Users Preferences:
/** @return {string} */
export function GET_USER_PREFERENCES_URL(userId) {
  return `/api/users/${userId}/preferences`;
}
// 2) Get User Preference With Key:
/** @return {string} */
export function GET_USER_PREFERENCES_WITH_KEY_URL(userId, preferenceKey) {
  return `/api/users/${userId}/preferences/${preferenceKey}`;
}
// 3) Get User Preference Value Options:
/** @return {string} */
export function GET_USER_PREFERENCE_VALUE_OPTIONS_URL(userId, preferenceKey) {
  return `/api/users/${userId}/preferences/${preferenceKey}/options`;
}
// 4) Create a User Preference:
/** @return {string} */
export function CREATE_USER_PREFERENCE_URL(userId) {
  return `/api/users/${userId}/preferences`;
}
// 5) Update a User Preference:
/** @return {string} */
export function UPDATE_USER_PREFERENCE_URL(userId, preferenceKey) {
  return `/api/users/${userId}/preferences/${preferenceKey}`;
}

// Absent Types
export const ABSENT_STUDENT = 'ABSENT_STU';
export const ABSENT_PROVIDER = 'ABSENT_PRV';

/** @return {boolean} */
export function IS_ABSENT(absentType) {
  return absentType === ABSENT_PROVIDER || absentType === ABSENT_STUDENT;
}

/** @return {boolean} */
export function IS_ABSENT_STU(absentType) {
  return absentType === ABSENT_STUDENT;
}

/** @return {boolean} */
export function IS_ABSENT_PROVIDER(absentType) {
  return absentType === ABSENT_PROVIDER;
}

// Service Delivered Constants
export const SD_GROUP = 'GROUP';
export const SD_INCLASS = 'INCLASS';
export const SD_INDIVIDUAL = 'INDIV';

export function IS_SD_REIMBURSABLE(serviceDelivered) {
  return serviceDelivered === SD_GROUP || serviceDelivered === SD_INCLASS || serviceDelivered === SD_INDIVIDUAL;
}

// GROUP TYPES
export const INDIVIDUAL = 'INDIV';
export const GROUP = 'GROUP';

export function SHOW_GROUP_TYPE(groupType) {
  return groupType === GROUP;
}

// DELIVERY MODE Constants
export const IN_PERSON = 'INPERSON';
export const TELEPRACTICE = 'TELEPRAC';

// Service Alternative Values
export const NOT_PROVIDED = 'NP';
export const ALT_ACTIVITY = 'ACTIVITY';
export const ALT_ARRANGEMENT = 'ARRANGE';

export function IS_ALT_SERVICE(serviceAlternative) {
  return serviceAlternative === ALT_ACTIVITY || serviceAlternative === ALT_ARRANGEMENT;
}



// WEBPACK FOOTER //
// ./src/constants/index.js